import React from "react";

function Piscine({ imgSrc, title, description }) {
  return (
    <figure className="figure" data-aos="fade-up" data-aos-duration="1000">
      <img src={imgSrc} alt={title} loading="lazy" className="figure-image" />
      <figcaption className="figure-caption">
        <h3 className="figure-caption-title">{title}</h3>
        <p className="figure-caption-p">{description}</p>
      </figcaption>
    </figure>
  );
}

export default Piscine;
